/* One Kickz · extraído de snippets/ok-seo-h1.liquid (19/10/2026) */
/* Lee cada foto (versión chica) para: 1) pintar el fondo de la galería con el color del fondo de la foto;
     2) en Colorway, recortar la zapatilla, centrarla y llevar su fondo a blanco. */
  (function () {
    var cache = {};
    function small(url, w) {
      try { var u = new URL(url, location.href); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
    }
    function analyse(url, cb) {
      var key = small(url, 240);
      if (cache[key]) { if (cache[key].done) cb(cache[key].r); else cache[key].q.push(cb); return; }
      var entry = cache[key] = { q: [cb], done: false, r: null };
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        var r = null;
        try {
          var W = im.naturalWidth, H = im.naturalHeight;
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, W, H).data;
          var px = function (i, j) { var k = (j * W + i) * 4; return [d[k], d[k + 1], d[k + 2], d[k + 3]]; };
          var pts = [[2, 2], [W - 3, 2], [2, H - 3], [W - 3, H - 3]].map(function (p) { return px(p[0], p[1]); });
          var transparent = pts.some(function (p) { return p[3] < 200; });
          var avg = [0, 1, 2].map(function (ch) { return Math.round(pts.reduce(function (a, p) { return a + p[ch]; }, 0) / 4); });
          var spread = Math.max.apply(null, pts.map(function (p) { return Math.abs(p[0] - avg[0]) + Math.abs(p[1] - avg[1]) + Math.abs(p[2] - avg[2]); }));
          var bg = transparent || spread > 36 ? [255, 255, 255] : avg;
          var x0 = W, y0 = H, x1 = -1, y1 = -1;
          for (var j = 0; j < H; j++) for (var i = 0; i < W; i++) {
            var k = (j * W + i) * 4, on;
            if (transparent) on = d[k + 3] > 24;
            else on = Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]) > 30;
            if (on) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (j < y0) y0 = j; if (j > y1) y1 = j; }
          }
          r = { W: W, H: H, bg: bg, plain: !transparent && spread <= 36, transparent: transparent,
                box: x1 > x0 && y1 > y0 ? { x0: x0, y0: y0, x1: x1 + 1, y1: y1 + 1 } : null };
        } catch (e) { r = null; }
        entry.done = true; entry.r = r;
        entry.q.forEach(function (f) { f(r); });
      };
      im.onerror = function () { entry.done = true; entry.q.forEach(function (f) { f(null); }); };
      im.src = key;
    }
    // 18/10/2026: solo la primera foto se analiza al cargar; el resto espera al evento load y a un momento libre
    // del navegador, para no competir con la foto principal (antes ~15 descargas extra antes del load).
    var ready = false, later = [];
    function whenIdle(fn) { if (ready) fn(); else later.push(fn); }
    function release() {
      if (ready) return; ready = true;
      var q = later; later = [];
      // 20/10/2026: con tope de 1,5 s; con animaciones en pantalla el navegador nunca queda "libre" y Colorway quedaba vacío.
      q.forEach(function (f) { if (window.requestIdleCallback) requestIdleCallback(f, { timeout: 1500 }); else setTimeout(f, 1); });
    }
    if (document.readyState === 'complete') setTimeout(release, 300);
    else window.addEventListener('load', function () { setTimeout(release, 300); });
    function rgb(c) { return 'rgb(' + c.join(',') + ')'; }
    function setImp(el, prop, val) { el.style.setProperty(prop, val); }

    function galleries() {
      document.querySelectorAll('.template--product .main-product__media .media').forEach(function (m, n) {
        if (m.dataset.okBg) return;
        var img = m.querySelector('img');
        if (!img || m.querySelector('video, iframe, model-viewer')) return;
        var src = img.currentSrc || img.src;
        if (!src) return;
        m.dataset.okBg = '1';
        (n === 0 ? function (f) { f(); } : whenIdle)(function () { analyse(src, function (r) {
          var col = r && r.plain ? rgb(r.bg) : '#fff';
          setImp(m, 'background-color', col);
          var item = m.closest('.main-product__media--grid-item');
          var idx = item && item.parentElement ? Array.prototype.indexOf.call(item.parentElement.querySelectorAll(':scope > .main-product__media--grid-item'), item) : -1;
          var thumbs = document.querySelectorAll('.ok-thumbs button');
          if (idx > -1 && thumbs[idx]) setImp(thumbs[idx], 'background-color', col);
        }); });
      });
    }

    var TARGET = 0.74;
    function colorways() {
      document.querySelectorAll('.product__product-group .product-option__label--image .product-option__link img').forEach(function (img) {
        if (img.dataset.okFit) return;
        var src = img.currentSrc || img.src;
        if (!src) return;
        img.dataset.okFit = '1';
        // En compu Colorway se ve arriba (sin análisis la zapatilla queda oculta): se analiza ya. En celular queda abajo: espera.
        (window.matchMedia('(min-width: 990px)').matches ? function (f) { f(); } : whenIdle)(function () { analyse(src, function (r) {
          if (!r || !r.box) { img.classList.add('ok-nofit'); return; }
          var b = r.box, bw = b.x1 - b.x0, bh = b.y1 - b.y0;
          var s = TARGET / Math.max(bw, bh);
          var w = r.W * s * 100, h = r.H * s * 100;
          var cx = (b.x0 + bw / 2) * s * 100, cy = (b.y0 + bh / 2) * s * 100;
          img.classList.add('ok-fit');
          setImp(img, 'inset', 'auto');
          setImp(img, 'width', w.toFixed(2) + '%');
          setImp(img, 'height', h.toFixed(2) + '%');
          setImp(img, 'left', (50 - cx).toFixed(2) + '%');
          setImp(img, 'top', (50 - cy).toFixed(2) + '%');
          if (!r.transparent) {
            var lum = Math.min(r.bg[0], r.bg[1], r.bg[2]);
            if (lum < 252 && lum > 170) img.style.filter = 'brightness(' + (255 / lum).toFixed(3) + ')';
          }
        }); });
      });
    }
    function run() { galleries(); colorways(); }
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 0); })
      .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

